import Tippy from "@tippyjs/react";
import styled, { keyframes } from "styled-components";
import "tippy.js/dist/tippy.css"; // optional

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 999;

  ul {
    margin: 0;
    padding: 0;
    li {
      list-style: none;
      padding: 2px 3px 2px 2px;
    }
  }

  span {
    border-radius: 4px;
    padding: 2px;

    background-color: ${({ status }) =>
      status === "doing"
        ? "#F8E47C"
        : status === "pending"
        ? "#EFF1F5"
        : status === "done"
        ? "#118052"
        : "#FFBAAB"};

    color: ${({ status }) =>
      status === "doing"
        ? "#786A23"
        : status === "pending"
        ? "#7E858F"
        : status === "done"
        ? "#EFF1F5"
        : "#D93333"};
  }
`;

const anim = keyframes`
  from {
    transform: translateY(-5px);
  }
  to {
    transform: translateY(-10px);
  }
`;

export const StyledTippy = styled(Tippy)`
  font-size: 12px;
  text-align: start;
  color: #fff;
  animation: ${anim} 400ms ease 0s 1 normal both running;
  background-color: #585e66;

  & > .tippy-arrow {
    color: #585e66;
  }
`;
